import styled from 'styled-components'
import { COLOR } from '../../assets/constants/constants'

export const ContainerBackground = styled.div`
  width: 100%;
  height: 100%;
  background: #1D3739;
  background-image: url(${p => p.image});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
`

export const ProductDetailDiv = styled.div`
  margin-top: 120px;
  margin-left: 80px;
  height: 80vh;
  width: 500px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  > div {
    margin-bottom: 30px;
  }

  @media (max-width: 767px) {
    margin-left: 0;
    margin-top: 0;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    padding: 20px;
  }
`;

export const HeaderMobile = styled.div`
  position: absolute;
  top: 20px;
  width: calc(100% - 40px);
  display: flex;
  justify-content: space-between;
  height: 40px;
  align-items: center;
  margin-bottom: auto;
`

export const StyledClose = styled.div`
  svg {
    width: 2em;
    height: 2em;

    path {
      stroke: #fff;
      stroke-width: 0.78;
    }
  }
`;

export const StyledButton = styled.div`
  cursor: pointer;
  border: 1px solid #fff;
  color: #fff;
  width: 154px;
  height: 38px;
  text-align: center;
  padding: 8px 10px;
  font-size: 14px;
  text-transform: uppercase;

  a {
    text-decoration: none;
    color: #fff;
  }

  :hover {
    color: ${COLOR.quaternary};
  }
`;
